import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class Aggregations extends BaseModel {
  constructor() {
    super(collection(db, 'analytics_data'))
  }
}
